import { SequenceMenu } from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'

export const ViewCustomerDetailsMenuItem = (props: {
  customerId: string
  onClose?: () => void
}) => {
  const navigate = useNavigate()

  return (
    <SequenceMenu.Item
      uuid="view-customer-details"
      label="View customer details"
      data-testid={`customers.${props.customerId}.menuItem.viewDetails`}
      onClick={() => {
        props.onClose?.()
        navigate(`/customers/${props.customerId}`)
      }}
    />
  )
}
